import { render, staticRenderFns } from "./RestaurantListPage.vue?vue&type=template&id=88602a28&"
import script from "./RestaurantListPage.vue?vue&type=script&lang=js&"
export * from "./RestaurantListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports